export let ResilienceMechanism;

(function (ResilienceMechanism) {
  ResilienceMechanism["INDEXEDDB"] = "indexeddb";
  ResilienceMechanism["MEMORY"] = "memory";
})(ResilienceMechanism || (ResilienceMechanism = {}));

export let NetworkStatusEnum;

(function (NetworkStatusEnum) {
  NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
  NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
})(NetworkStatusEnum || (NetworkStatusEnum = {}));